import { render } from "./ReferralView.vue?vue&type=template&id=c3417f56&scoped=true"
import script from "./ReferralView.vue?vue&type=script&lang=js"
export * from "./ReferralView.vue?vue&type=script&lang=js"

import "./ReferralView.vue?vue&type=style&index=0&id=c3417f56&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\StrinGent\\Desktop\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3417f56"]])

export default __exports__